/**
 * different status of process for downloading / zipping
 */
export const TASK_STATUS = Object.freeze({
  cancelled: "cancelled",
  downloading: "downloading",
  uploading: "uploading",
  zipping: "zipping",
  complete: "complete",
  failed: "failed",
} as const);

/**
 * different typeof tasks
 */
export const TASK_TYPES = Object.freeze({
  download: "download",
  upload: "upload",
} as const);
